export default __webpack_public_path__ + "media/9bf0a83e91e8623e2421355921923fe699b81922973bde28d00c12933b904df5.svg";